import { Flex, Box, Text } from '@chakra-ui/react';
import DetailCard from '../shared/DetailCard';
import DetailRow from '../shared/DetailRow';
import { formatDate } from '../../../../utils/formatDate';

interface TokenAssociationDetailsProps {
  tokenId: string;
  tokenName?: string;
  tokenSymbol?: string;
  onCopy: (text: string) => void;
  onTokenClick: () => void;
  expiresAt?: number;
  waitForExpiry?: boolean;
  isMultisig: boolean;
  isManual: boolean;
  createdBy?: { name: string; accountId: string };
}

const TokenAssociationDetails = ({
  tokenId,
  tokenName,
  tokenSymbol,
  onCopy,
  onTokenClick,
  expiresAt,
  waitForExpiry,
  isMultisig,
  isManual,
  createdBy,
}: TokenAssociationDetailsProps) => (
  <DetailCard>
    <DetailRow
      label="Token ID"
      value={
        <Text
          size="sm"
          variant="bodyBold"
          color="blue.500"
          cursor="pointer"
          _hover={{ textDecoration: 'underline' }}
          onClick={(e) => {
            e.stopPropagation();
            onTokenClick();
          }}
        >
          {tokenId}
        </Text>
      }
      onCopy={() => onCopy(tokenId)}
    />
    {tokenName && <DetailRow label="Name" value={tokenName} />}
    {tokenSymbol && <DetailRow label="Symbol" value={tokenSymbol} />}
    {createdBy && (
      <DetailRow
        label="Created by"
        value={createdBy.name ? `${createdBy.name} (${createdBy.accountId})` : createdBy.accountId}
      />
    )}
    {isMultisig && expiresAt && (
      <DetailRow
        label={isManual ? 'Executes At' : 'Expires'}
        value={
          <Flex alignItems="center" gap={2}>
            <Box px={2} py={0.5} bg="blackAlpha.50" borderRadius={4}>
              <Text size="xs" color="blackAlpha.700" whiteSpace="nowrap">
                {formatDate(expiresAt)}
              </Text>
            </Box>
            {waitForExpiry && !isManual && (
              <Box px={1.5} py={0.5} bg="orange.100" borderRadius={4}>
                <Text size="xs" color="orange.700" fontWeight="600" fontSize="10px" whiteSpace="nowrap">
                  ⏱ Wait for Expiry
                </Text>
              </Box>
            )}
          </Flex>
        }
      />
    )}
  </DetailCard>
);

export default TokenAssociationDetails;
